import React, { useCallback } from 'react'
import VerificationResendHeader from './VerificationResendHeader'

// This component handles the input for the verification number, ensuring it is a 6-digit number
// and suppots a resend functionality with cooldown.

type VerificationCodeProps = {
  onVerificationCodeChange: (value: string) => void
  onResendVerificationCode: () => void
}

const VerificationCode: React.FC<VerificationCodeProps> = ({
  onVerificationCodeChange,
  onResendVerificationCode,
}) => {
  const [codeError, setCodeError] = React.useState<string | null>(null)

  const handleOnChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/\D/g, '')
      //e.target.value = value

      if (value.length > 0 && value.length != 6) {
        e.target.value = value.slice(0, 6) // Limit to 6 digits
        setCodeError('Verification number must be 6 digits')
      }
      if (value.length === 6) {
        setCodeError(null) // Clear error when valid input is entered
        onVerificationCodeChange(value)
      }
    },
    [onVerificationCodeChange, setCodeError],
  )

  return (
    <>
      <div className="mt-6 flex flex-col items-center mb-1">
        <VerificationResendHeader
          maxCooldown={30}
          onResend={onResendVerificationCode}
        />
        <input
          id="verification_number"
          type="text"
          className="p-3 text-input-content flex items-center w-full rounded-8 my-1 transition-shadow bg-white has-[:disabled]:bg-neutral-200 has-[:disabled]:shadow-input-disabled has-[:disabled]:cursor-not-allowed hover:shadow-input-active has-[:focus]:shadow-input-focus shadow-input"
          onChange={handleOnChange}
        />
      </div>
      {codeError && <p className="text-red-500 text-sm mt-0">{codeError}</p>}
    </>
  )
}

export default VerificationCode
